import { mixin, vars } from '@src/services/theme';

export const login = `

.login {
    display: block !important;
    ${mixin.center}
    min-width: 600px;
    padding: 20px;
    background: ${vars.colors.white};
    border-radius: 20px;
    border: 3px solid ${vars.colors.black};

    > header {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
        font-size: 30px;
        font-weight: bold;

        > img {
            width: 80px;
            margin-right: 1em;
        }
    }

    .login-form {
        margin-top: 4em;
    }

    .login-privacy {
        h4 {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            text-transform: uppercase;
        }
        p {
            font-size: 12px;
        }
        footer {
            font-size: 16px;
            font-weight: bold;
            nav {
                text-align: right;
                a {
                    display: inline-block;
                    margin-left: 1em;
                    font-size: 14px;
                    text-decoration: underline;
                }
            }
        }
    }

    > footer {
        display: flex;
        width: 100%;
        margin-top: 20px;

        > * {
            flex: 1;
        }

        a {
            font-size: 14px;
            text-decoration: underline;
            color: ${vars.colors.greyDark};
        }
    }
}
`;


// WEBPACK FOOTER //
// ./src/styles/common.ts